import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantSaleRoomDto } from './merchantSaleRoom.dto';

export class MerchantSaleUnitCombinationDto extends BaseDto {
  noPersons: number;
  minNoPersons: number;
  merchantSaleUnitIds: [number];
  merchant: MerchantDto;
  saleRoom: MerchantSaleRoomDto;
  area?: string;
  section?: string;
  merchantSaleUnitIdentifiers: string;
}
